export default __webpack_public_path__ + "static/landing-page-image-83500b3b67ff0a1766c86486539e9fc1.png";